module.exports = __webpack_public_path__ + "img/罗汉果.4c961722.jpg";